const PlusBadge = () => (
  <span
    className="ml-2 inline-block px-2 py-0.5 text-[10px] font-semibold rounded-full leading-tight"
    style={{ backgroundColor: '#C9A84C', color: '#1A1A1A' }}
  >
    PLUS
  </span>
);

export default PlusBadge;
